export const METRICS_COMPONENT_TYPE = {
  OVER_TIME: {
    name: 'Overtime',
    icon: 'chart-line'
  },
  LIST: {
    name: 'List',
    icon: 'list-ol',
    configOptions: {
      values: {
        name: 'value',
        items: [
          {
            name: 'type',
            title: 'List by',
            options: [
              { label: 'Total', value: 'total' },
              { label: 'Ranking', value: 'ranking' }
            ]
          },
          {
            name: 'numberOfItems',
            title: '# of items',
            options: []
          },
          {
            name: 'listSize',
            title: 'List size',
            options: [
              { label: 'Wide', value: 'wide' },
              { label: 'Narrow', value: 'narrow' }
            ]
          },
          {
            name: 'sortOrder',
            title: 'Sort Order',
            options: [
              { label: 'Descending', value: 'descending' },
              { label: 'Ascending', value: 'ascending' }
            ]
          }
        ]
      }
    }
  },
  NUMBER: {
    name: 'Number',
    icon: 'calculator',
    configOptions: {
      values: {
        name: 'value',
        items: [
          {
            name: 'type',
            title: 'Type of value',
            options: [
              { label: 'Total Value', value: 'total' },
              { label: 'Average Value', value: 'average' }
            ]
          },
          {
            name: 'time_range',
            title: 'Time Range',
            options: [
              { label: 'Daily', value: 'daily' },
              { label: 'Weekly', value: 'weekly' },
              { label: 'Monthly', value: 'monthly' },
              { label: 'All-time', value: 'all-time' }
            ]
          }
        ]
      },
      benchmark: {
        name: 'benchmark',
        items: [
          {
            name: 'total_change',
            title: 'Total Change',
            component: 'select',
            item: {
              title: 'Time Range',
              name: 'time_range',
              options: [
                { label: 'Daily', value: 'daily' },
                { label: 'Weekly', value: 'weekly' },
                { label: 'Monthly', value: 'monthly' }
              ]
            }
          }, {
            title: 'Comparison',
            name: 'comparison',
            component: 'select',
            item: {
              title: 'Time Range',
              name: 'time_range',
              options: [
                { label: 'Daily', value: 'daily' },
                { label: 'Weekly', value: 'weekly' },
                { label: 'Monthly', value: 'monthly' }
              ]
            }
          }, {
            title: 'Goal',
            name: 'goal',
            component: 'input',
            item: {
              title: 'Goal Amount',
              name: 'goal',
              options: []
            }
          }
        ]
      }
    }
  }
};

const { OVER_TIME, LIST, NUMBER } = METRICS_COMPONENT_TYPE;

const Metrices = [
  {
    name: 'Survey Participants',
    supportedComponents: [NUMBER, LIST],
    restrictToUsers: ['List']
  },
  {
    name: 'Issued Rewards',
    supportedComponents: [NUMBER, LIST],
    restrictToUsers: []
  },
  {
    name: 'Trials Ending',
    supportedComponents: [LIST],
    restrictToUsers: ['List']
  },
  {
    name: 'Active Surveys',
    supportedComponents: [LIST],
    restrictToUsers: ['List']
  },
  {
    name: 'Business Leads',
    supportedComponents: [NUMBER],
    restrictToUsers: ['Number']
  },
  {
    name: 'Redeemed Rewards',
    supportedComponents: [NUMBER],
    restrictToUsers: []
  }
];

export default Metrices;



// WEBPACK FOOTER //
// ./src/configs/dashboardMetrices.js